import { Component, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faConnectdevelop } from '@fortawesome/free-brands-svg-icons';
import {
  faScaleBalanced,
  faChartSimple,
  faCode,
  faSquarePollVertical,
  faRobot,
  faSyncAlt,
  faChartLine,
  faComments,
  faNetworkWired,
  faDumbbell,
  faHospital,
  faMoneyBillWave,
  faMugHot,
  faUtensils,
  faHospitalSymbol,
  faStethoscope,
  faCreditCard,
  faPrescriptionBottleMedical,
  faUserShield,
  faShip,
  faHandshake,
  faUserPlus,
  faAnchor,
} from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-grid-cards-with-frame',
  templateUrl: './grid-cards-with-frame.component.html',
  styleUrls: ['./grid-cards-with-frame.component.css'],
})
export class GridCardsWithFrameComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;

  // Add faScaleBalanced to the icons map
  icons: { [key: string]: IconProp } = {
    faScaleBalanced,
    faChartSimple,
    faCode,
    faSquarePollVertical,
    faRobot,
    faSyncAlt,
    faChartLine,
    faComments,
    faNetworkWired,
    faHospitalSymbol,
    faHospital,
    faUtensils,
    faDumbbell,
    faMugHot,
    faMoneyBillWave,
    faConnectdevelop,
    faAnchor,
    faStethoscope,
    faCreditCard,
    faPrescriptionBottleMedical,
    faUserShield,
    faShip,
    faHandshake,
    faUserPlus,
  };

  constructor(library: FaIconLibrary) {
    // Add faScaleBalanced to the library
    library.addIcons(
      faScaleBalanced,
      faRobot,
      faSyncAlt,
      faChartLine,
      faComments,
      faNetworkWired,
      faHospitalSymbol,
      faHospital,
      faUtensils,
      faDumbbell,
      faMugHot,
      faMoneyBillWave,
      faChartSimple,
      faCode,
      faSquarePollVertical,
      faConnectdevelop,
      faAnchor,
      faStethoscope,
      faCreditCard,
      faPrescriptionBottleMedical,
      faUserShield,
      faShip,
      faHandshake,
      faUserPlus,
    );
  }

  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${this.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
